<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <div class="whatsapp-container">
        <a :href="message.data.metadata.whatsapp" class="button" target="_blank" @click="handleClick">
          <img src="../assets/whatsapp.png"> Falar com um consultor
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from './../store/'

export default {
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    }
  },
  methods: {
    handleClick () {
      window.EventBus.$emit('SEND_GTM_EVENT', {
        event: 'gaEvent',
        eventCategory: "RobocoteClicouBotaoWhatsApp",
        eventAction: null,
        eventLabel: null,
        eventValue: null
      });
    }
  }
}
</script>

<style scoped>
  .container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .whatsapp-container {
    display: flex;
  }
  .button {
    display: flex;
    align-items: center;
    margin: 10px 5px 5px 0;
    padding: 10px 15px;
    border-radius: 5px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    border: 0;
    text-decoration: none;
    background: #445a64;
    color: #fff;
  }
  .button:hover {
    opacity: .8;
  }
  .button img {
    width: 20px;
    margin-right: 10px;
  }
</style>
